import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgIf} from "@angular/common";

@Component({
    selector: 'cdss-create-therapeutic-schedule-modal',
    imports: [
        NgIf
    ],
    templateUrl: './create-therapeutic-schedule.modal.component.html',
    styleUrl: './create-therapeutic-schedule.modal.component.scss'
})
export class CreateTherapeuticScheduleModalComponent implements OnInit {

    type: number;

    constructor(
        public activeModal: NgbActiveModal,
        public modal: NgbModal,
    ) {
    }

    ngOnInit() {
    }

    submit() {
        this.activeModal.close({});
    }

}
